export const enum AgeRange {
  EIGHTEEN = '18-29',
  THIRTY = '30-39',
  FORTY = '40-49',
  FORTY_FIVE = '45-54',
  FIFTY = '50-59',
  FIFTY_FIVE = '55-64',
  SIXTY = '60-69',
  SIXTY_FIVE = '65-74',
  MORE_THAN_FIFTY = '50+',
  MORE_THAN_SEVENTY = '70+',
  MORE_THAN_SEVENTY_FIVE = '75+',
}

export const enum BodyShape {
  APPLE = 'apple',
  PEAR = 'pear',
  HOURGLASS = 'hourglass',
  TRIANGLE = 'inverted_triangle',
  RECTANGLE = 'rectangle_shaped',
  NOT_SURE = 'im_not_sure',
}
